import { getOptInProgressCookie } from '../cookies/preferredClientCookies';

export type IsOptInUnderProgress = () => boolean;
export const isOptInUnderProgress: IsOptInUnderProgress = () => getOptInProgressCookie() === 'modern';
